import { useState } from 'react';
import BookingModal from '../../../components/feature/BookingModal';

interface Vehicle {
  name: string;
  price: string;
  fuel: string;
  seats: number;
  transmission: string;
  image: string;
  features: string[];
  exteriorImages: string[];
  interiorImages: string[];
}

export default function VehicleList() {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState<Vehicle | null>(null);
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentTab, setCurrentTab] = useState<'exterior' | 'interior'>('exterior');

  const vehicles: Vehicle[] = [
    {
      name: '현대 아반떼 모던',
      price: '70,000',
      fuel: '가솔린',
      seats: 5,
      transmission: '자동(22년식)',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/3432664fdfa1d1645311ceef61eddcf2.png',
      features: ['2채널블박', '후방카메라', '스마트키', '네비,통풍시트,열선핸들 등'],
      exteriorImages: [
        'https://public.readdy.ai/ai/img_res/8998f4f5bb22a482d4b39839977aeaf2.jpg',
        'https://readdy.ai/api/search-image?query=Hyundai%20Avante%20compact%20sedan%20exterior%20side%20profile%20view%20on%20clean%20white%20studio%20background%2C%20elegant%20body%20lines%2C%20professional%20automotive%20photography%2C%20realistic%20lighting%2C%20high%20quality%20car%20photo&width=800&height=600&seq=avante_ext_2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Avante%20compact%20sedan%20exterior%20rear%20view%20on%20clean%20white%20studio%20background%2C%20modern%20tail%20lights%2C%20professional%20automotive%20photography%2C%20realistic%20lighting%2C%20high%20quality%20car%20photo&width=800&height=600&seq=avante_ext_3&orientation=landscape'
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Hyundai%20Avante%20interior%20dashboard%20and%20steering%20wheel%20view%2C%20modern%20digital%20display%2C%20premium%20materials%2C%20comfortable%20seats%2C%20professional%20automotive%20interior%20photography%2C%20realistic%20lighting%2C%20clean%20elegant%20design&width=800&height=600&seq=avante_int_1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Avante%20interior%20front%20seats%20view%2C%20comfortable%20leather%20seats%2C%20spacious%20cabin%2C%20center%20console%2C%20professional%20automotive%20interior%20photography%2C%20realistic%20lighting%2C%20premium%20quality&width=800&height=600&seq=avante_int_2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Avante%20interior%20rear%20seats%20view%2C%20spacious%20legroom%2C%20comfortable%20seating%2C%20professional%20automotive%20interior%20photography%2C%20realistic%20lighting%2C%20modern%20design&width=800&height=600&seq=avante_int_3&orientation=landscape'
      ]
    },
    {
      name: '현대 캐스퍼 인스퍼레이션',
      price: '60,000',
      fuel: '가솔린 터보',
      seats: 5,
      transmission: '자동(24년식)',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/93a125d688080fc70d0186c3482d5690.png',
      features: ['2채널블박', '후방카메라', '스마트키', '네비 , 열선핸들 , 통풍시트 등'],
      exteriorImages: [
        'https://readdy.ai/api/search-image?query=Hyundai%20Casper%20Turbo%20compact%20SUV%20exterior%20front%20view%20on%20clean%20white%20studio%20background%2C%20cute%20modern%20design%2C%20professional%20automotive%20photography%2C%20realistic%20lighting%2C%20high%20quality%20car%20photo&width=800&height=600&seq=casper_ext_1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Casper%20Turbo%20compact%20SUV%20exterior%20side%20profile%20view%20on%20clean%20white%20studio%20background%2C%20sporty%20body%20lines%2C%20professional%20automotive%20photography%2C%20realistic%20lighting%2C%20high%20quality%20car%20photo&width=800&height=600&seq=casper_ext_2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Casper%20Turbo%20compact%20SUV%20exterior%20rear%20view%20on%20clean%20white%20studio%20background%2C%20distinctive%20tail%20design%2C%20professional%20automotive%20photography%2C%20realistic%20lighting%2C%20high%20quality%20car%20photo&width=800&height=600&seq=casper_ext_3&orientation=landscape'
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Hyundai%20Casper%20Turbo%20interior%20dashboard%20and%20steering%20wheel%20view%2C%20modern%20digital%20display%2C%20sporty%20design%2C%20comfortable%20seats%2C%20professional%20automotive%20interior%20photography%2C%20realistic%20lighting%2C%20clean%20design&width=800&height=600&seq=casper_int_1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Casper%20Turbo%20interior%20front%20seats%20view%2C%20comfortable%20seats%2C%20compact%20cabin%2C%20center%20console%2C%20professional%20automotive%20interior%20photography%2C%20realistic%20lighting%2C%20modern%20quality&width=800&height=600&seq=casper_int_2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Hyundai%20Casper%20Turbo%20interior%20rear%20seats%20view%2C%20efficient%20space%20usage%2C%20comfortable%20seating%2C%20professional%20automotive%20interior%20photography%2C%20realistic%20lighting%2C%20practical%20design&width=800&height=600&seq=casper_int_3&orientation=landscape'
      ]
    },
    {
      name: '기아 레이 터보 시그니처',
      price: '70,000',
      fuel: '가솔린',
      seats: 5,
      transmission: '자동(26년식)',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/3818ea5b615eddf7c27a47c143e56839.jpeg',
      features: ['2채널 블박', '후방카메라', '스마트키', '열선핸들 , 열선시트, 네비 , 후방카메라'],
      exteriorImages: [
        'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/3818ea5b615eddf7c27a47c143e56839.jpeg',
        'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/b969c43dc08a7de6541bbe5616321153.jpeg',
        'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/c3bc9a337634d7b223b19b6a51efc02b.jpeg'
      ],
      interiorImages: [
        'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/3eb394d795584a7e88e645fe36230711.jpeg',
        'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/c3bc9a337634d7b223b19b6a51efc02b.jpeg',
        'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/bc8a86cb0ca786b221f4cd266511cffe.jpeg'
      ]
    },
    {
      name: '기아 모닝 프레스트지',
      price: '70,000',
      fuel: '가솔린',
      seats: 5,
      transmission: '자동(22년식)',
      image: 'https://static.readdy.ai/image/d842605c752dbbdb50edbc13280091c2/281ba358b7cf2ffa0a28721e8ce23c6d.png',
      features: ['2채널블박', '후방카메라', '에어컨'],
      exteriorImages: [
        'https://readdy.ai/api/search-image?query=Kia%20Morning%20compact%20city%20car%20exterior%20front%20view%20on%20clean%20white%20studio%20background%2C%20friendly%20cute%20design%2C%20professional%20automotive%20photography%2C%20realistic%20lighting%2C%20high%20quality%20car%20photo&width=800&height=600&seq=morning_ext_1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20Morning%20compact%20city%20car%20exterior%20side%20profile%20view%20on%20clean%20white%20studio%20background%2C%20efficient%20body%20lines%2C%20professional%20automotive%20photography%2C%20realistic%20lighting%2C%20high%20quality%20car%20photo&width=800&height=600&seq=morning_ext_2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20Morning%20compact%20city%20car%20exterior%20rear%20view%20on%20clean%20white%20studio%20background%2C%20compact%20tail%20design%2C%20professional%20automotive%20photography%2C%20realistic%20lighting%2C%20high%20quality%20car%20photo&width=800&height=600&seq=morning_ext_3&orientation=landscape'
      ],
      interiorImages: [
        'https://readdy.ai/api/search-image?query=Kia%20Morning%20interior%20dashboard%20and%20steering%20wheel%20view%2C%20simple%20modern%20display%2C%20economical%20design%2C%20comfortable%20seats%2C%20professional%20automotive%20interior%20photography%2C%20realistic%20lighting%2C%20clean%20design&width=800&height=600&seq=morning_int_1&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20Morning%20interior%20front%20seats%20view%2C%20comfortable%20seats%2C%20compact%20cabin%20space%2C%20center%20console%2C%20professional%20automotive%20interior%20photography%2C%20realistic%20lighting%2C%20practical%20quality&width=800&height=600&seq=morning_int_2&orientation=landscape',
        'https://readdy.ai/api/search-image?query=Kia%20Morning%20interior%20rear%20seats%20view%2C%20adequate%20legroom%2C%20comfortable%20seating%2C%20professional%20automotive%20interior%20photography%2C%20realistic%20lighting%2C%20efficient%20design&width=800&height=600&seq=morning_int_3&orientation=landscape'
      ]
    }
  ];

  const openGallery = (vehicle: Vehicle, tab: 'exterior' | 'interior' = 'exterior') => {
    setSelectedVehicle(vehicle);
    setCurrentTab(tab);
    setCurrentImageIndex(0);
    setIsGalleryOpen(true);
  };

  const closeGallery = () => {
    setIsGalleryOpen(false);
    setSelectedVehicle(null);
    setCurrentImageIndex(0);
  };

  const getCurrentImages = () => {
    if (!selectedVehicle) return [];
    return currentTab === 'exterior' ? selectedVehicle.exteriorImages : selectedVehicle.interiorImages;
  };

  const nextImage = () => {
    const images = getCurrentImages();
    setCurrentImageIndex((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    const images = getCurrentImages();
    setCurrentImageIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <>
      <section className="py-12 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-6">
            {vehicles.map((vehicle, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group"
              >
                <div className="relative h-48 sm:h-56 overflow-hidden">
                  <img
                    src={vehicle.image}
                    alt={vehicle.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                </div>

                <div className="p-4 md:p-5">
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">{vehicle.name}</h3>
                  <p className="text-2xl md:text-3xl font-extrabold text-primary mb-1">₩{vehicle.price}</p>
                  <p className="text-sm text-gray-500 mb-4">자차별도</p>
                  
                  <div className="grid grid-cols-2 gap-3 mb-4 text-sm text-gray-600">
                    <div className="flex items-center text-xs sm:text-sm text-gray-600">
                      <i className="ri-gas-station-line text-primary mr-2"></i>
                      <span>{vehicle.fuel}</span>
                    </div>
                    <div className="flex items-center text-xs sm:text-sm text-gray-600">
                      <i className="ri-user-line text-primary mr-2"></i>
                      <span>{vehicle.seats}인승</span>
                    </div>
                    <div className="flex items-center text-xs sm:text-sm text-gray-600">
                      <i className="ri-settings-line text-primary mr-2"></i>
                      <span>{vehicle.transmission}</span>
                    </div>
                  </div>

                  <div className="flex flex-wrap gap-1.5 md:gap-2 mb-4">
                    {vehicle.features.map((feature, idx) => (
                      <span
                        key={idx}
                        className="px-2 md:px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-xs"
                      >
                        {feature}
                      </span>
                    ))}
                  </div>

                  {/* 이미지 갤러리 버튼 */}
                  <div className="flex gap-2 mb-4">
                    <button
                      onClick={() => openGallery(vehicle, 'exterior')}
                      className="flex-1 px-3 py-2 bg-gray-100 text-gray-700 text-xs md:text-sm font-medium rounded-lg hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-image-line mr-1"></i>
                      외부사진
                    </button>
                    <button
                      onClick={() => openGallery(vehicle, 'interior')}
                      className="flex-1 px-3 py-2 bg-gray-100 text-gray-700 text-xs md:text-sm font-medium rounded-lg hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      <i className="ri-steering-2-line mr-1"></i>
                      내부사진
                    </button>
                  </div>

                  <a
                    href="tel:010-5437-1535"
                    className="w-full px-4 py-2.5 md:py-3 bg-gradient-to-r from-primary to-secondary text-white text-sm md:text-base font-semibold rounded-lg hover:shadow-lg transition-all cursor-pointer whitespace-nowrap block text-center"
                  >
                    <i className="ri-calendar-check-line mr-2"></i>
                    예약하기
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 이미지 갤러리 모달 */}
      {isGalleryOpen && selectedVehicle && (
        <div className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4">
          <div className="relative w-full max-w-5xl bg-white rounded-2xl overflow-hidden">
            {/* 헤더 */}
            <div className="bg-gray-900 text-white p-4 md:p-6">
              <div className="flex items-center justify-between mb-4">
                <h3 className="text-xl md:text-2xl font-bold">{selectedVehicle.name}</h3>
                <button
                  onClick={closeGallery}
                  className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-white/20 transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              
              {/* 탭 */}
              <div className="flex gap-2">
                <button
                  onClick={() => {
                    setCurrentTab('exterior');
                    setCurrentImageIndex(0);
                  }}
                  className={`px-4 py-2 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    currentTab === 'exterior'
                      ? 'bg-white text-gray-900'
                      : 'bg-white/10 text-white hover:bg-white/20'
                  }`}
                >
                  <i className="ri-image-line mr-2"></i>
                  외부사진
                </button>
                <button
                  onClick={() => {
                    setCurrentTab('interior');
                    setCurrentImageIndex(0);
                  }}
                  className={`px-4 py-2 rounded-lg font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    currentTab === 'interior'
                      ? 'bg-white text-gray-900'
                      : 'bg-white/10 text-white hover:bg-white/20'
                  }`}
                >
                  <i className="ri-steering-2-line mr-2"></i>
                  내부사진
                </button>
              </div>
            </div>

            {/* 이미지 슬라이더 */}
            <div className="relative bg-gray-100">
              <div className="relative aspect-video">
                <img
                  src={getCurrentImages()[currentImageIndex]}
                  alt={`${selectedVehicle.name} ${currentTab === 'exterior' ? '외부' : '내부'} ${currentImageIndex + 1}`}
                  className="w-full h-full object-contain"
                />
                
                {/* 이전/다음 버튼 */}
                {getCurrentImages().length > 1 && (
                  <>
                    <button
                      onClick={prevImage}
                      className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-black/50 hover:bg-black/70 text-white rounded-full transition-colors cursor-pointer"
                    >
                      <i className="ri-arrow-left-s-line text-2xl"></i>
                    </button>
                    <button
                      onClick={nextImage}
                      className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-black/50 hover:bg-black/70 text-white rounded-full transition-colors cursor-pointer"
                    >
                      <i className="ri-arrow-right-s-line text-2xl"></i>
                    </button>
                  </>
                )}

                {/* 이미지 카운터 */}
                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black/70 text-white px-4 py-2 rounded-full text-sm">
                  {currentImageIndex + 1} / {getCurrentImages().length}
                </div>
              </div>

              {/* 썸네일 */}
              <div className="p-4 flex gap-2 overflow-x-auto">
                {getCurrentImages().map((img, idx) => (
                  <button
                    key={idx}
                    onClick={() => setCurrentImageIndex(idx)}
                    className={`flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden border-2 transition-all cursor-pointer ${
                      idx === currentImageIndex
                        ? 'border-primary scale-105'
                        : 'border-transparent opacity-60 hover:opacity-100'
                    }`}
                  >
                    <img
                      src={img}
                      alt={`썸네일 ${idx + 1}`}
                      className="w-full h-full object-cover"
                    />
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      <BookingModal isOpen={isBookingModalOpen} onClose={() => setIsBookingModalOpen(false)} />
    </>
  );
}
